export default "__VITE_ASSET__080ed9cb__"